import { ProductCard, type ProductCardVariant } from '@/components/product-card'
import type { Product } from '@/types/database'
import { cn } from '@/lib/utils'

interface ProductGridProps {
  products: Product[]
  discountPercent?: number
  className?: string
  emptyMessage?: string
  variant?: ProductCardVariant
}

export function ProductGrid({
  products,
  discountPercent,
  className,
  emptyMessage = 'No products found',
  variant = 'default',
}: ProductGridProps) {
  if (products.length === 0) {
    return (
      <div className="py-12 text-center">
        <p className="text-muted-foreground">{emptyMessage}</p>
      </div>
    )
  }

  return (
    <div className={cn(
      'grid gap-6 sm:grid-cols-2 lg:grid-cols-3',
      className
    )}>
      {products.map((product) => (
        <ProductCard
          key={product.id}
          product={product}
          discountPercent={discountPercent}
          variant={variant}
        />
      ))}
    </div>
  )
}
